import {
  Box
} from "@primer/react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { lichSuXuongPhongYTeApi } from "../../../api/lichSuXuongPhongYTeApi";
import DataTable from "../../../components/ui/data-table";
import { useCommonSelectedHook } from "../../../hooks/useCommonSelectedHook";
import { ILichSuXuongPhongYTe } from "../../../models/response/crm-hocsinh/ILichSuXuongPhongYTe";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";

interface LichSuXuongPhongYTeProps {
  hocSinhId: number;
}

const LichSuXuongPhongYTePage: React.FC<LichSuXuongPhongYTeProps> = ({ hocSinhId }) => {
  const { nam_hoc } = useCommonSelectedHook();
  const [namHocSelected, setNamHocSelected] = useState<string>("");
  const [listXuongPhongYTe, setListXuongPhongYTe] = useState<ILichSuXuongPhongYTe[]>([]);

  useEffect(() => {
    setNamHocSelected(nam_hoc);
  }, [nam_hoc]);

  useEffect(() => {
    if (namHocSelected && hocSinhId) {
      getLLichSuXuongPhongYTe();
    }
  }, [namHocSelected, hocSinhId]);

  const getLLichSuXuongPhongYTe = async () => {
    try {
      const res = await lichSuXuongPhongYTeApi.selectByHocSinh(
          hocSinhId
        );
      if (res.is_success && res.data) {
        setListXuongPhongYTe(res.data);
      } else {
        setListXuongPhongYTe([]);
      }
    } catch (error) {
      console.error("Error fetching mien giam list:", error);
      setListXuongPhongYTe([]);
    }
  };

  return (
    <Box sx={{ paddingTop: 15 }}>
      <DataTable
        height={`400px`}
        actionComponent={
          <Box
            sx={{
              display: "flex",
              gap: 2,
            }}
          >
          
          </Box>
        }
        columns={[      
          {
            dataField: "nhom_noi_dung",
            width: "100px",
            caption: `Loại`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TextWithEllipse text={data.nhom_noi_dung || ""} lineNumber={1} />
                </Box>
              );
            },
          },        
          {
            dataField: "tinh_trang",
            width: "auto",
            caption: `Tình trạng`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TextWithEllipse text={data.tinh_trang || ""} lineNumber={1} />
                </Box>
              );
            },
          },
            {
            dataField: "ket_qua",
            width: "auto",
            caption: `Kết quả`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  <TextWithEllipse text={data.ket_qua || ""} lineNumber={1} />
                </Box>
              );
            },
          },
          {
            dataField: "ngay_tao",
            width: "auto",
            caption: `Ngày tạo`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {moment(data.ngay_tao).format("DD/MM/YYYY")  || ""}
                </Box>
              );
            },
          },
          {
            dataField: "ngay_cap_nhat",
            width: "auto",
            caption: `Ngày sửa`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {moment(data.ngay_cap_nhat).format("DD/MM/YYYY") || ""}
                </Box>
              );
            },
          },
          {
            dataField: "nguoi_tao",
            width: "auto",
            caption: `Người tạo`,
            cellRender: (data: ILichSuXuongPhongYTe) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.nguoi_tao || ""}
                </Box>
              );
            },
          },
        ]}
        data={listXuongPhongYTe}
        title="Lịch sử xuống phòng y tế"
        searchEnable
      />
    </Box>
  );
};

export default LichSuXuongPhongYTePage;
